import { SAMPLE_TYPES } from '@/consts/genetic-tests';
import { isValidOrderCode } from './order-code-validation';

// Format: DDMMYYYY-HHMMSS-MMM-XXX (order code + separator + sample type short code)
const ORDER_CODE_LENGTH = 19;
const SEPARATOR = '-';
const SAMPLE_SHORT_CODE_LENGTH = 3;
const SAMPLE_TYPE_CODE_LENGTH =
  ORDER_CODE_LENGTH + SEPARATOR.length + SAMPLE_SHORT_CODE_LENGTH; // 23

export const isValidSampleTypeCode = (code: string): boolean => {
  if (code.length !== SAMPLE_TYPE_CODE_LENGTH) {
    return false;
  }

  // Extract and validate the order code part
  const orderCodePart = code.substring(0, ORDER_CODE_LENGTH);
  if (!isValidOrderCode(orderCodePart)) {
    return false;
  }

  // Validate separator
  if (code.charAt(ORDER_CODE_LENGTH) !== SEPARATOR) {
    return false;
  }

  // Validate the sample type short code suffix
  const sampleShortCode = code.substring(ORDER_CODE_LENGTH + SEPARATOR.length);

  return SAMPLE_TYPES.some((st) => st.shortCode === sampleShortCode);
};
